export default __webpack_public_path__ + "static/media/Logo-circle.f6800321.png";